package com.exura.components.pageTypography

import androidx.compose.runtime.Composable
import com.exura.ui.Dimens
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier

@Composable
internal fun TitledSection(
    modifier: Modifier = Modifier,
    title: String,
    content: @Composable () -> Unit,
) {
    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(Dimens.pageSectionTitleGap)
    ) {
        SpanText(title, modifier = ExuraTextStyle.toModifier(ExuraSectionHeaderTextVariant))
        Box(modifier = Modifier.fillMaxWidth().padding(left = Dimens.pageSecondaryLevelIndent).then(modifier)) {
            content()
        }
    }
}
